import { render, staticRenderFns } from "./ManageDeliveryTypes.vue?vue&type=template&id=4566b95b"
import script from "./ManageDeliveryTypes.vue?vue&type=script&lang=ts"
export * from "./ManageDeliveryTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports